export function makeTabName(tabTitle: string): string {
    return tabTitle?.replace(
      /^\w|[A-Z]|\b\w|\s+/g,
      function (match, index) {
          if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
          return index === 0 ? match.toLowerCase() : match.toUpperCase();
      }
    );
}


export function handleLazyLoadImage(element) {
    if (element.src) {
      if (isInViewport(element)) {
        const image = element.shadowRoot.querySelector('img');
        if (image.getAttribute('src') != element.src && !image.dataset.hasOwnProperty('hasError')) {
          image.setAttribute('src', element.src);
        }
      }
    }
}

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const html = document.documentElement;
    return (
      rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || html.clientHeight) &&
        rect.right <= (window.innerWidth || html.clientWidth)
    );
}
